import React from 'react';
import ItemCommerce from './section-commerce-item';

import { Accordion } from 'react-bootstrap';

const CommerceList = ({ commerces, onCommerceSelect }) => {
  return (
    <Accordion defaultActiveKey={'0'}>
      {
        commerces && commerces.length ?
          commerces.map((item, index) => {
            return <ItemCommerce data={{ item, index }} key={index} onCommerceSelect={onCommerceSelect} />
          })
          : ''
      }
    </Accordion>
  );
}

export default CommerceList;